import React, { createContext, useContext, useMemo, useState } from "react";

const ToastCtx = createContext({ add: () => {} });
export const useToast = () => {
  const { add } = useContext(ToastCtx);
  return Object.assign(
    (opts) => add(opts),
    {
      success: (message, title = "Success") => add({ title, message, variant: "success" }),
      error:   (message, title = "Error")   => add({ title, message, variant: "error" }),
      info:    (message, title = "Info")    => add({ title, message, variant: "info" }),
    }
  );
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const add = ({ title, message = "", variant = "info", duration = 3000 }) => {
    const id = Math.random().toString(36).slice(2);
    setToasts((t) => [...t, { id, title, message, variant }]);
    if (duration > 0) setTimeout(() => dismiss(id), duration);
  };
  const dismiss = (id) => setToasts((t) => t.filter((x) => x.id !== id));

  const bg = (v) =>
    v === "success" ? "var(--brand-primary)" :
    v === "error"   ? "#ef4444" :
    v === "info"    ? "var(--brand-accent)" : "var(--brand-surface)";

  const text = (v) => (v === "success" || v === "info" ? "#0b0f19" : "var(--brand-text)");

  const value = useMemo(() => ({ add, dismiss }), []);

  return (
    <ToastCtx.Provider value={value}>
      {children}
      <div className="fixed bottom-4 right-4 z-[1000] space-y-2">
        {toasts.map((t) => (
          <div
            key={t.id}
            className="rounded-xl shadow-lg p-3 w-80 cursor-pointer"
            onClick={() => dismiss(t.id)}
            style={{ background: bg(t.variant), color: text(t.variant) }}
          >
            <div className="font-semibold">{t.title}</div>
            {t.message ? <div className="text-sm opacity-90">{t.message}</div> : null}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}
